import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OperationalStatusEntity } from './operational-status.entity';

@Index(
	'_operational_status_history__fk__operational_status__id_fk',
	['fkOperationalStatusId'],
	{},
)
@Entity('_operational_status_history')
export class OperationalStatusHistoryEntity extends BaseEntity {
	@Column('int', { name: '_fk__operational_status__id', unsigned: true })
	public fkOperationalStatusId!: number;

	@Column('varchar', { name: '_status', length: 20 })
	public status!: string;

	@Column('text', { name: '_message' })
	public message!: string;

	@ManyToOne(
		() => OperationalStatusEntity,
		(operationalStatus) => operationalStatus.operationalStatusHistories,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__operational_status__id', referencedColumnName: 'id' },
	])
	public fkOperationalStatus!: OperationalStatusEntity;
}
